import React from "react";
import { useRecoilState } from "recoil";
import { confirmModalState, ModalType } from "../../recoil/confirm";
import styled from "styled-components";

const ConfirmRecoilModal: React.FC = () => {
  const [modalStates, setModalStates] =
    useRecoilState<ModalType>(confirmModalState);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  };

  const closeModal = () => {
    setModalStates((prev) => ({
      ...prev,
      visibleConfirm: false,
      handleConfirm: null,
      title: "",
      successText: "",
      cancelText: "",
      shouldReload: false,
    }));
  };

  const handleConfirm = () => {
    closeModal();

    if (modalStates.handleConfirm) {
      modalStates.handleConfirm();
    }
    if (modalStates.shouldReload) {
      window.location.reload();
      scrollToTop();
    }
  };

  return (
    <Style>
      {modalStates.visibleConfirm && (
        <div className="modalWrap">
          <div className="modal">
            <h2 className="modalTitle">{modalStates.title}</h2>
            <div className="buttonWrap">
              {modalStates?.cancelText !== undefined && (
                <button className="cancelText" onClick={handleConfirm}>
                  {modalStates?.cancelText}
                </button>
              )}
              <button className="successText" onClick={handleConfirm}>
                {modalStates?.successText}
              </button>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default ConfirmRecoilModal;

const Style = styled.div`
  .modalWrap {
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
  }
  .modal {
    display: inline;
    width: auto;
    padding: 37px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    border-radius: 20px;
    background: #000000;
    border: 1px solid #a7a7a7;
  }
  h2 {
    margin-top: 50px;
    font-size: 30px;
    font-weight: 400;
    color: #fff;
    line-height: 48px;
    white-space: pre-line;
  }
  img {
    width: 100%;
    max-width: 36px;
  }
  .buttonWrap {
    width: 100%;
    display: inline-flex;
    margin-top: 50px;
    gap: 18px;
  }
  button {
    flex: 1;
    padding: 20px 90px;
    border-radius: 10px;
    font-size: 36px;
    font-weight: 700;
  }
  .successText {
    background: linear-gradient(180deg, #6490e8 0%, #001e62 100%);
    color: #fff;
  }
  .cancelText {
    background: linear-gradient(180deg, #a4a4a4 0%, #353535 100%);
    color: #fff;
  }
  @media (max-width: 700px) {
    .modal {
      width: 85%;
      padding: 24px;
    }
    h2 {
      font-size: 16px;
      line-height: 32px;
    }
  }
`;
